import api from '@/services/utils/base';
import qs from 'qs';
import store from '@/store';

export default class ReportAPI {
  getSupportedDimensions() {
    return api.get('/report/supported-dimensions').then((res: any) => {
      store.commit('setDimensions', res.data.payload);
    });
  }

  getSupportedMetrics() {
    return api.get('/report/supported-metrics').then((res: any) => {
      store.commit('setMetrics', res.data.payload);
    });
  }

  getReport(params: object) {
    return api.get('/report', {
      params: {
        ...params,
        presetId:store.state.report.activePreset
      },
      paramsSerializer: function(params: object) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    });
  }

  getReportUri(params: object) {
    return api.getUri({
      method: 'GET',
      url: api.config.baseURL + '/report',
      params: {
        ...params,
        presetId:store.state.report.activePreset
      },
      paramsSerializer: function(params: object) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    });
  }

  getAggregatedReport(period: string, params: object) {
    return api.get(`/report/aggregated/${period}`, {
      params: { 
        ...params,
        presetId:store.state.report.activePreset 
      },
      paramsSerializer: function(params: object) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    });
  }
}
